export default theme => ({
  externalLink: {
    textDecoration: "none",
    whiteSpace: "pre-wrap",
    cursor: "pointer",
  },
});
